<form [formGroup]="form" (ngSubmit)="login()">
  <div class="container-inputs gap-3">
    <ng-container *ngFor="let control of formControls; let i = index">
      <div class="input-container">
        <div class="relative">
          <label [for]="control.name"></label>
          <input
            [id]="control.name"
            autocomplete="off"
            aria-label="submit-data"
            class="input-with-icon"
            [type]="control?.type ? control.type : 'text'"
            formControlName="{{ control.name }}"
            [placeholder]="control?.placeholder ? control.placeholder : ''"
          />
          <ng-container *ngFor="let icon of control?.icon">
            <span [class]="icon.placement">
              <ng-container *ngIf="icon.placement == 'left-icon'">
                <img
                  loading="lazy"
                  (click)="showPassClick(icon, i)"
                  [@rotatedState]="state"
                  [src]="icon.src"
                  [alt]="icon.alt"
                  width="20px"
                  height="15px"
                />
              </ng-container>
              <ng-container *ngIf="icon.placement == 'right-icon'">
                <img
                  loading="lazy"
                  [src]="icon.src"
                  [alt]="icon.alt"
                  width="20px"
                  height="15px"
                />
              </ng-container>
            </span>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="col-span-2">
      <app-toggle (checked)="rememberMe = $event" [name]="'rememberme'">
        <strong after class="mx-1.5 font-black">مرا به خاطر بسپار</strong>
      </app-toggle>
    </div>
    <button
      name="login"
      aria-label="لاگین"
      [disabled]="form.invalid || loading"
      class="button-submit relative rounded-lg text-white font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 col-span-2"
      type="submit"
    >
      ورود
    </button>
  </div>
</form>
<p class="text-small font-black text-black mt-2">
  رمز عبور خود را فراموش کرد‌ید؟
  <button
    type="submit"
    aria-label="بازیابی رمز عبور"
    name="forgetPass"
    class="text-blue-800 p-0 m-0 bg-transparent cursor-pointer"
    (click)="forgetPass()"
  >
    بازیابی رمز عبور
  </button>
</p>
<p class="text-small font-black text-black mt-2">
  حساب کاربری ندارید؟
  <button
    type="button"
    aria-label="ثبت نام"
    name="signup"
    class="text-blue-800 p-0 m-0 bg-transparent cursor-pointer"
    (click)="changeToSignup()"
  >
    ثبت نام کنید
  </button>
</p>
